import { createApp, watch } from "vue"
import i18n from '@/i18n'
import App from "./App.vue"
import router from "@/router/router"
import { store } from "@/store/store"
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import Notifications from "@kyvg/vue3-notification"
import vClickOutside from "click-outside-vue3"
import "vite/modulepreload-polyfill"
import utils from "@/utils/utils"
import ApiService from "@/services/ApiService"

const app = createApp(App)

app.use(router)

const baseHref = "/" + utils.getCurrentSubdomain()
store.dispatch("setBaseHref", baseHref)
app.use(store)

app.use(Notifications)

watch(
    () => store.state.messages,
    (newMessages) => {
        i18n.global.setLocaleMessage("fi", newMessages.fi)
        i18n.global.setLocaleMessage("sv", newMessages.sv)
        i18n.global.setLocaleMessage("en", newMessages.en)
    }
)

const apiService = new ApiService(baseHref)
apiService.getLanguageTerms().then(response => {
    store.dispatch("setMessages", response)

    app.use(i18n)

    app.use(vClickOutside)
}).finally(() => {
    app.mount('#app')
})
